/**
 * 用户进入首页的状态场景值
 */
export enum UserHomeSceneEnums {
  /** 无标签用户 */
  TAGLESS = 'tagless',
  /** 品质用户 */
  QUALITY = 'quality',
  /** 预授信 */
  PRE_CREDIT = 'preCredit',
  /** 老客升级 */
  UPGRADE = 'upgrade',
  /** 零用钱 */
  POCKET_MONEY = 'pocketMoney',
}

/** 预授信场景 */
export enum PreCreditUserSourceEnums {
  /** 普通(端内用户) */
  NORMAL = '0',
  /** 投放用户 */
  ADVERTISING = '1',
  /** 老客 */
  OLD_CUSTOMER = '2',
  /** 非投放新客 */
  NO_ADVERTISING_NEW_CUSTOMER = '3',
  /** 零用钱 */
  POCKET_MONEY = '4',
  /** 海消用户  */
  SEA_CONSUMER = '5',
}

/** 普通预授信模式 */
export enum NormalPreCreditModelEnums {
  /** 授信流程 */
  CREDIT = 'credit',
  /** 提现流程 */
  LOAN = 'loan',
  /** 零用钱提现流程 */
  POCKET_MONEY_LOAN = 'pocketMoneyLoan',
}
